export class TermsConditionActivityLog
{
    id: string = '';
    termsAndConditionId: string = '';
    driverHashId: string = '';
    actionId: number;
    actionDateTime: string = '';
    acceptanceMoment: number;
    bookingId: string = '';
    cTGId: string = '';
    
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/termsconditionpopup/models/terms-condition.model.ts